<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm03_title"></a><a id="page_vii"></a><strong>The Pleasing Hour</strong></h1>
<p class="center"><span class="small">A NOVEL BY</span></p>
<p class="author"><strong>Lily King</strong></p>
<p class="pub"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?3ea34818